import { Button, Flex, Text, TextInput } from "@gravity-ui/uikit";
import { useAction, useAtom } from "@reatom/npm-react";
import cn from "classnames";
import { ChangePasswordDto } from "definitions/poizon-sso";
import { SubmitHandler, useForm } from "react-hook-form";
import { Form, useNavigate, useSearchParams } from "react-router-dom";
import { appConfig } from "src/config";
import { RoutesPaths } from "src/routes/RoutesPaths";
import { resetPasswordRequest } from "src/store/fetchers/resetPasswordRequest";

import css from "./ResetPwdPage.module.scss";

interface IResetPassword extends ChangePasswordDto {
  password_repeat?: string;
}

export const ResetPwdPage = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const email = searchParams.get("email");
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<IResetPassword>({
    mode: "onChange",
    defaultValues: { code: code ?? "", email: email ?? "" },
  });

  const [isLoading] = useAtom(resetPasswordRequest.isLoadingAtom);
  const resetPassword = useAction(resetPasswordRequest);

  if (!code) {
    navigate(RoutesPaths.AUTH.LOGIN);
    return;
  }
  const onSubmit: SubmitHandler<IResetPassword> = (data) => {
    delete data.password_repeat;
    resetPassword(data);
  };
  const password = watch("password", "");
  return (
    <Flex className={cn(css.main, css.full)}>
      <Flex className={cn(css.main, css.mainContainer)}>
        <Flex className={css.main}>
          <appConfig.logo
            height={50}
            onClick={() => navigate(RoutesPaths.LANDING)}
            className={css.footerLogo}
          />
          <Text variant="display-1">Смена пароля</Text>
        </Flex>
        <Form className={css.resetForm} onSubmit={handleSubmit(onSubmit)}>
          <div className={css.resetFormInputContainer}>
            <TextInput
              placeholder="Новый пароль"
              {...register("password", {
                required: "Обязательное поле",
                minLength: { value: 8, message: "Минимальная длина 8" },
              })}
              size="xl"
              label="Пароль"
              type="password"
              validationState={errors.password ? "invalid" : undefined}
              errorMessage={errors.password?.message}
              errorPlacement="outside"
            />
          </div>
          <div className={css.resetFormInputContainer}>
            <TextInput
              placeholder="Новый пароль"
              {...register("password_repeat", {
                required: "Обязательное поле",
                validate: (value) => value == password || "Пароли не совпадают",
              })}
              size="xl"
              label="Пароль"
              type="password"
              validationState={errors.password_repeat ? "invalid" : undefined}
              errorMessage={errors.password_repeat?.message}
              errorPlacement="outside"
            />
          </div>
          <Flex
            className={css.regFormInputContainer}
            direction={"column"}
            alignItems={"center"}
            gap={"3"}
          >
            <Button
              className={css.regButton}
              view="action"
              size="l"
              type="submit"
              loading={isLoading}
            >
              Сменить пароль
            </Button>
          </Flex>
        </Form>
      </Flex>
    </Flex>
  );
};
